import React, { useEffect, useRef } from "react";
import { InkleFileData } from "components/fileTax/FileCompleteDocuments";
import {
  FilePreviewWithoutGroup,
  LocalFilePreview,
  Preview,
} from "components/PreviewModal";

type UnifiedPreviewProps = {
  localPreviewFile: File | null;
  remotePreviewFile: InkleFileData | null;
  closeModal: () => void;
};

export const UnifiedPreviewWithoutGroup = ({
  localPreviewFile,
  remotePreviewFile,
  closeModal,
}: UnifiedPreviewProps) => {
  if (localPreviewFile) {
    return (
      <LocalFilePreview
        isOpen={Boolean(localPreviewFile)}
        file={localPreviewFile}
        close={closeModal}
      />
    );
  }

  if (remotePreviewFile) {
    return (
      <FilePreviewWithoutGroup
        showModal={Boolean(remotePreviewFile)}
        closeModal={closeModal}
        previewId={remotePreviewFile.uuid}
      />
    );
  }

  return null;
};
